import { Routes } from '@angular/router';

export const historyRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./history.page').then((m) => m.HistoryPage),
  },
];
